import { Button, ButtonBar } from "@/overlay/components/CommonParts/buttons";
import { Modal } from "@/overlay/components/window/Modal";
import { t } from "@lingui/core/macro";
import styles from "./Modal.module.scss";

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  itemName?: string; // Optional, in case you want to display item name
}

export const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  itemName,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className={styles.container}>
        <h2>{t`Confirm Deletion`}</h2>
        <p>
          {itemName ? t`Are you sure you want to delete "${itemName}"?` : t`Are you sure you want to delete this item?`}
        </p>
        <div className={styles.buttonGroup}>
          <ButtonBar>
            <Button data-testid="confirmation-cancel" onClick={(e) => onClose()}>
              {t`Cancel`}
            </Button>

            <Button data-testid="confirmation-yes" onClick={(e) => onConfirm()} styleRemove>
              {t`Delete`}
            </Button>
          </ButtonBar>
        </div>
      </div>
    </Modal>
  );
};
